import { v4 as uuidv4 } from "uuid";

export const generateUniqueId = () => {
  return uuidv4();
};

export const returnGameTypeText = (gameType) => {
  return gameType === "OMAHA5" ? "PLO5" : gameType === "OMAHA" ? "PLO4" : "NLH";
};
